import { Grid, Link, Stack, Typography } from '@mui/material';
import { shorterDateFormat } from 'Config';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface IInformation {
  isSentToUser: boolean;
  docDate: string;
  docRequestNumber?: string;
  docLinkedRequestNumbers?: string[];
  documentSubject?: string;
}

export const Information = ({
  isSentToUser,
  docDate,
  docRequestNumber,
  docLinkedRequestNumbers,
  documentSubject,
}: IInformation) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Stack gap='6px'>
          <Typography variant='body6'>
            {isSentToUser ? dictionary.receiveDate : dictionary.sentDate}
          </Typography>
          <Typography variant='body2'>
            {format(new Date(docDate), shorterDateFormat)}
          </Typography>
        </Stack>
      </Grid>

      {docRequestNumber && (
        <Grid item xs={6}>
          <Stack gap='6px'>
            <Typography variant='body6'>{dictionary.requestNumber}</Typography>
            <Link
              variant='body2'
              sx={{
                width: 'fit-content',
              }}
            >
              {docRequestNumber}
            </Link>
          </Stack>
        </Grid>
      )}

      {docLinkedRequestNumbers && docLinkedRequestNumbers.length > 0 && (
        <Grid item xs={6}>
          <Stack gap='6px'>
            <Typography variant='body6'>{dictionary.linkedRequest}</Typography>

            {docLinkedRequestNumbers.map((reqNumber: string, index: number) => {
              return (
                <Link
                  key={index}
                  variant='body2'
                  sx={{
                    width: 'fit-content',
                  }}
                >
                  {reqNumber}
                </Link>
              );
            })}
          </Stack>
        </Grid>
      )}

      {documentSubject && (
        <Grid item xs={6}>
          <Stack gap='6px'>
            <Typography variant='body6'>{dictionary.fileType}</Typography>
            <Typography variant='body2'>{documentSubject}</Typography>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};
